export default __webpack_public_path__ + "static/bubble-with-categories-c762c02c76fd1472fe2ec4d498f90832.png";